//import './bootstrap';
//import './meta';
import { configureAxios } from './axios';
import configureErrorHandling from './handle-errors';

export * from './i18n';
export * from './router';
export * from './axios';

export function configure(app, store) {
  return Promise.all([
    configureAxios(store),
    configureErrorHandling(app, store),
  ]);
}
